// extracted by mini-css-extract-plugin
export var ExternalLink = "cta-download-module--ExternalLink--eb98a";
export var SideColumnDownloadImage = "cta-download-module--SideColumnDownloadImage--16d63";
export var SideColumnText = "cta-download-module--SideColumnText--ae327";
export var SideColumnTitle = "cta-download-module--SideColumnTitle--a2baf";
export var body = "cta-download-module--body--9dca7";